import { RouteComponentProps } from "@reach/router";
import React from "react";

interface IScrollToTopProps extends RouteComponentProps {
  children?: React.ReactNode;
}
export const ScrollToTop = (props: IScrollToTopProps) => {
  React.useEffect(() => {
    globalThis.window.scrollTo(0, 0);
  }, [props.location?.pathname]);

  return <>{props.children} </>;
};
